import { render, staticRenderFns } from "./SourceUrlLinkRenderer.vue?vue&type=template&id=5f21efea&scoped=true&"
import script from "./SourceUrlLinkRenderer.vue?vue&type=script&lang=js&"
export * from "./SourceUrlLinkRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SourceUrlLinkRenderer.vue?vue&type=style&index=0&id=5f21efea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21efea",
  null
  
)

export default component.exports